import './buffer-setup';
import { createRoot } from 'react-dom/client';
import { App } from './App';
export const STATIC_BASE_URL = import.meta.env.VITE_STATIC_URI;

const root = document.getElementById('root');
if (root) {
  createRoot(root).render(<App />);
}
